export const files = {
  title: 'Pliki',
  searchByName: 'Wyszukaj',
  delete: 'Usuń model',
  deleteDisabled:
    'Nie można usunąć pliku, ponieważ jest używany w jednej z konfiguracji',
  preview: 'Podgląd modelu',
  previewClose: 'Zamknij podgląd',
  correctlyUploaded: 'Poprawnie utworzony?',
  status: 'Status',
  statuses: {
    success: 'Poprawny',
    error: 'Niepoprawny',
    pending: 'W trakcie',
  },
  deleteSuccess: 'Poprawnie usunięto model',
  label: 'Nazwa',
  code: 'Kod',
  dimensions: 'Wymiary modelu',
  dimensionX: 'Wymiary X',
  dimensionY: 'Wymiary Y',
  dimensionZ: 'Wymiary Z',
  noFileFound: 'Nie znaleziono pliku z tym id',
  loadingFile: 'Ładowanie pliku',
  detailsTitle: 'Szczegóły pliku',
  tabs: {
    general: 'Dane pliku',
    dependence: 'Zależności',
    tree: 'Struktura',
  },
  notifications: {
    update: 'Zmiany zostały zapisane',
  },
  noResults: 'Brak',
  infoButton: 'Informacje na temat pliku',
  noDimensions: 'Brak wymiarów',
}
